<template>
  <div class="checkout-form">
    <div v-if="loading" class="checkout-form__loading">
      <p>{{ $t('common.loading') }}</p>
    </div>

    <div
      v-else
      class="registration-fields-wrapper checkout-form__fields form-container"
    >
      <FormItem
        v-for="item in visibleFields"
        :key="item.id"
        :item="item"
        :backend="backend"
        :form-data="store.formData"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import FormItem from '@landingpage/Registration/components/FormItem.vue'
import { useVisibilityRules } from '@landingpage/Registration/composables/useVisibilityRules'
import { useCheckoutFormStore } from '@landingpage/Registration/composables/useCheckoutFormStore'

const props = defineProps({
  fields: {
    type: Object,
    required: true,
  },
  backend: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const store = useCheckoutFormStore()

const visibleFields = computed(() => {
  if (!props.fields?.items) return []

  const { evaluateVisibilityRules } = useVisibilityRules(store.formData)

  return props.fields.items
    .filter((item) => {
      if (item.hidden) return false
      if (!item.visibility_rules) return true
      return evaluateVisibilityRules(item.visibility_rules)
    })
    .map((item) => ({
      ...item,
      render_type: item.type,
      form_mapping: store.getFieldPath(item) || item.field?.key || '',
      label: item.field?.label || '',
      options: item.field?.options || [],
      core_id: item.field?.core_id || null,
      limits: item.field?.limits || null,
      display_availability: item.display_availability ?? false,
    }))
})
</script>
